export default "__VITE_ASSET__CJ6YofNy__"